// @flow

import type { APIError } from '../types'

export function getErrorAction(
  type: string,
  error: APIError,
  statusText: ?string
): Object {
  return {
    type: type,
    payload: {
      status: error.response.status,
      statusText: statusText || error.response.statusText
    }
  }
}

export const doesUserHaveAppAccess = (user: Object): boolean =>
  user.organizations.length > 0

export const removeLockedOutOrganizations = (user: Object): boolean => ({
  ...user,
  organizations: user.organizations.filter(
    o => !(
      o.application_flags?.includes('qw_lockout_students') &&
      o.roles.includes('qa_student')
    )
  )
})
